export const MEDICO = '$2y$12$9dhFVEGXN2aZh0tz4GC8g.f.W3rwY4xnwb6DieaAoNYti.QwnRjDa';
export const ENFERMERO = '$2y$12$8YKyxjJVXauC8IW9DCXStuQYzWvR26YIFThVLQeMVrtzbGKmd1x1W';
export const SALUD_MENTAL = '$2y$12$28zhL1cEJI.smWIKRzaiaOJ0RH.RUlyr9QY3NU3jwsrL6lsFYP8Ee';
export const RAYOS = '$2y$12$glxjJoqa7wZUakG0MUKTPuqMmTa/A5c9SzW/74LRsPtiyOPy5oHve';
export const KINESILOGIA = '$2y$12$cQmOV2mQUYH.3zfpyn8hc.9A9Znj4IXD2g.4E2OWmAbBXRs4GG7aW';
export const NUTRICION = '$2y$12$gp.IURMdULQqjehUZXCLCeBm0L0HKoPufWsujkgXx1THRk8VQgKly';
export const LABORATORIO = '$2y$12$/dMcIn8Wz09qF6z6vrN1/egjrDN9jvTGEzSVZT9o/ABjqs1dqMHx2';
export const HEMOTERAPIA = '$2a$12$vUroYbbakpFDtb/oooLkQuYeX0esGoV4S2nqUY4vPtiX1coSeGRLO';
